import React from 'react';
import { grey } from '@mui/material/colors';
import { ListEmpty, ListLoading } from 'components/shared/List';
import { camelCaseToNormal } from 'utils/formatters';
import { Remove, BuildCircle } from '@mui/icons-material';
import { Stack, Typography, IconButton, Tooltip, Chip, Button } from '@mui/material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { useChargesConfiguration } from '../../api';

interface Props {
  isLoading: boolean;
  listOfWorkflow: any[];
  onConfigureWorkflow: (index: number) => void;
}

export const SalesCenterWorkflow = ({ listOfWorkflow, onConfigureWorkflow, isLoading }: Props) => {
  const { handleDeleteConfiguration, isConfigurationDeleting } = useChargesConfiguration();

  return (
    <Stack className="salesCenterCard" gap="1rem">
      <Typography variant="h6" component="span">
        Workflow Rules
      </Typography>

      <Stack gap="1rem">
        <RenderWithFallback isLoading={isLoading} fallBack={<ListLoading />}>
          <RenderWithCondition condition={!!listOfWorkflow.length} fallBack={<ListEmpty />}>
            {listOfWorkflow.map((workflow, index) => (
              <Stack
                sx={{
                  gap: '0.5rem',
                  width: '100%',
                  padding: '1rem',
                  borderRadius: '0.2rem',
                  border: `1px solid ${grey[300]}`,
                }}
              >
                <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
                  <Stack gap="0.5rem" flexWrap="wrap" direction="row">
                    {Object.entries(workflow.dealRules).map(([key, value]) => (
                      <RenderWithCondition condition={!!value && !key.startsWith('_')}>
                        <Chip
                          key={key}
                          size="small"
                          color="primary"
                          variant="filled"
                          label={<Typography variant="caption">{`${camelCaseToNormal(key)}: ${value}`}</Typography>}
                        />
                      </RenderWithCondition>
                    ))}
                  </Stack>

                  <Stack direction="row" gap="0.5rem">
                    <Button
                      size="small"
                      startIcon={<BuildCircle fontSize="small" />}
                      onClick={() => onConfigureWorkflow(index)}
                    >
                      Configure
                    </Button>

                    <Tooltip title="Remove configuration">
                      <IconButton
                        size="small"
                        color="error"
                        className="icon-btn-bordered"
                        loading={isConfigurationDeleting}
                        onClick={() =>
                          handleDeleteConfiguration({ id: workflow.id }, api => ({
                            refetchQueries: [api.getConfigs],
                            awaitRefetchQueries: true,
                          }))
                        }
                      >
                        <Remove />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </Stack>

                <Typography>
                  Apply for:{' '}
                  {Object.entries(workflow.dealRules)
                    .filter(([key, value]) => !!value && !key.startsWith('_'))
                    .map(([_, value]) => value)
                    .join(' + ')}
                </Typography>

                <Typography>
                  {workflow.charges.meta.amountOfFees} Fees, {workflow.charges.meta.amountOfTaxes} Taxes configured
                </Typography>
              </Stack>
            ))}
          </RenderWithCondition>
        </RenderWithFallback>
      </Stack>
    </Stack>
  );
};
